<template>
  <div class="container-fluid no-gutters">
    <!-- 第一部分：背景图与文字 -->
    <!-- <div class="container-fluid no-gutters">
      <img src="../../public/images/home/screen.png"
           class="img-fluid rounded" alt="...">
    </div> -->

<div class="container-fluid">
      <carousel :autoplayTimeout="5000"
 :per-page="1" :autoplay="true" :loop="true">
        <slide v-for="(image,index) in carouselList" :key="index">
          <img  class="w-100 h-80" :src="require(`@/assets/images/cooperation/carousel/${image.path}.png`)" alt="">
        </slide>
      </carousel>
    </div>

    <!-- 第二部分：分左右两栏 -->
    <div class="container" >
      <div class="row pt-4 mt-3 mx-4 mb-1 align-items-center justify-content-center">
        <div class="col-12">
          <h1 class="mt-1 mb-1 boldText">{{ $t("h.product_introduction") }}</h1> <br/>
          <p class="text-left text-black-50 font-class-ref">
            {{ $t("h.product_introduction_detail") }}
          </p>
        </div>
      </div>
    </div>

    <div class="container mb-5 mt-0">
      <div class="row" style="height: 100%;">
        <div class="col-12 text-left mt-5  pb-md-5 position-relative mw-100 h-auto">
          <img  class="img-fluid" src="../../public/images/home/earth-row.png"
               style=" border-radius: 15px;">
          <div class="position-absolute mt-5 ml-5">
            <span class="font-weight-bold" style="color: white; font-size: 3.5vw">200+</span>
            <br>
            <span class="font-weight-bold" style="color: white; font-size: 3.5vw">Clients</span>
          </div>
        </div>
      </div>

    </div>


    <!-- 第三部分：文本+图片交替显示 -->
    <div class="container-fluid " >
      <div class="pt-2 pb-2 position-relative"
           :style="{ backgroundImage: 'url(' + require('@/assets/images/home/bg.png')+ ')' }">

        <div class="row two-image-class m-5 mb-md-1"  >
          <div style="border-radius: 15px;" class="card">
            <div  class="row align-items-center no-gutters home-text-7">
              <div class="col-md-6">
                <img style="border-radius:15px" src="../../public/images/home/image1.png" class="card-img" alt="Card image">
              </div>
              <div class="col-md-6">
                <div class="card-body pt-md-0">
                  <h3 class="card-title text-left font-weight-bold boldText">{{ $t("h.expertise") }}</h3>
                  <br>
                  <p class="card-text text-left font-class-ref-1 text-black-50">
                    {{ $t("h.expertise_paragraphs_1") }}
                  </p>
                  <p class="card-text text-left font-class-ref-1 text-black-50">
                    {{ $t("h.expertise_paragraphs_2") }}
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="row two-image-class m-5 mb-md-1" style="padding-top: 0;">
          <div style="border-radius: 15px;" class="card">
            <div class="row align-items-center no-gutters">

              <div class="col-md-6">
                <div class="card-body pt-md-0">
                  <h3 class="card-title text-left font-weight-bold boldText">{{ $t("h.team") }}</h3>
                  <br>
                  <p class="card-text text-left font-class-ref-1 text-black-50">
                    {{ $t("h.teamBg_1") }}
                  </p>
                  <p class="card-text text-left font-class-ref-1 text-black-50">
                    {{ $t("h.teamBg_2") }}
                  </p>
                </div>
              </div>

              <div class="col-md-6">
                <img style="border-radius: 15px" src="../../public/images/home/image2.png"
                     class="card-img rounded-image" alt="Card image">
              </div>
            </div>
          </div>
        </div>

        <!-- 如果有更多文本+图片对，继续添加div元素 -->
      </div>
    </div>

    <!-- 第四部分：标题与圆形图片列表 -->
    <div class="container guoqibody">
      <div class="pt-3 pb-4 text-center home-text-7 ">
        <h3 class="boldText service-scope">{{ $t("h.service_scope") }}</h3>
        <div class="mt-2 mx-4">
          <div class="row justify-content-center">
            <div class="col-md-3 col-8" v-for="(image,index) in images" :key="index">
              <img  style="border: 1px solid #d3cece;
    border-radius: 15px;" :src="require(`../../public/images/country/${image.name}.png`)" :alt="image.alt"
                   class="img-fluid rounded-image country-class">
              <p class="mt-2 font-class-ref">{{ image.countryName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      images: [],
       carouselList: [
        // {
        //   path: "1",
        //   title: "1",
        //   alt: "...",
        // },
      
        {
          path: "3",
          title: "3",
          alt: "...",
        },
          {
          path: "2",
          title: "2",
          alt: "...",
        }
      ],
    };
  },
  created() {
    this.updateImages();
  },
  watch: {
    '$i18n.locale'() {
      this.updateImages();
    }
  },
  methods: {
    // data中可能导致国际化无法更新
    updateImages() {
      this.images = [
        {
          name: "us",
          alt: this.$t("h.us"),
          countryName: this.$t("h.us"),
        },
        {
          name: "India",
          alt: this.$t("h.india"),
          countryName: this.$t("h.india"),
        },
        {
          name: "pak",
          alt: this.$t("h.pakistan"),
          countryName: this.$t("h.pakistan"),
        },
        {
          name: "afh",
          alt: this.$t("h.afghanistan"),
          countryName: this.$t("h.afghanistan")
        },
        {
          name: "sllk",
          alt: this.$t("h.slb"),
          countryName: this.$t("h.slb"),
        },
        {
          name: "bd",
          alt: this.$t("h.bt"),
          countryName: this.$t("h.bt"),
        },

        {
          name: "nbe",
          alt: this.$t("h.npl"),
          countryName: this.$t("h.npl"),
        },
        {
          name: "other",
          alt: this.$t("h.orRegion"),
          countryName: this.$t("h.orRegion"),
        }
      ]
    }
  }
};
</script>

<style >


.guoqibody{
  padding-bottom: 3em;
}

.service-scope{
  margin-top: 1.5em;
    margin-bottom: 1.5em;
}

.bg-image {
  background-size: cover;
  height: 300px; /* 根据需要调整高度 */
  color: white;
  position: relative;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.boldText{
  font-size: 40px;
    font-weight: 700;
}

.jumbotron h1 {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
}

.home-text-1 {
  border-left-width: 1px;
  border-left-color: #212529;
  border-left-style: solid;
}

.home-text-7 {
  //background-color: rgba(241, 243, 242);
}

.container-fluid {
  padding: 0;
}

.bg-image-container {
  /* 确保容器有足够的高度来显示背景图片 */
  height: 100vh; /* 或者使用 100vh, 100%, 等，根据你的需求来定 */
  background-image: url('../assets/images/home/earth-row.png');
  background-size: auto; /* 保持图片的原始大小 */
  background-position: center; /* 图片居中 */
  background-repeat: no-repeat; /* 不重复背景图片 */
  /* 可能还需要添加一些其他的样式，比如 overflow: hidden; 来隐藏超出容器的部分 */
}

.rounded-image {
  /*border-top-left-radius: calc(0.25rem - -10px) !important;
  border-top-right-radius: calc(0.25rem - -10px) !important;
  border-bottom-left-radius: calc(0.25rem - -10px) !important;
  border-bottom-right-radius: calc(0.25rem - -10px) !important;*/
}

/*默认字体大小*/
.font-class-ref {
  font-size: 1.6vw
}

.font-class-ref-1 {
  font-size: 1.3vw
}

.country-container-class {
  width: 100%;
}

.country-class {
  width: 270px;
  height: 150px;
}

.bg-home-image-container {
  /* 确保容器有足够的高度来显示图片和渐变 */
  height: 90vh; /* 或根据您的需求调整 */
  overflow: hidden; /* 防止图片或渐变溢出容器 */
}
.pt-md-0, .py-md-0 {
        padding-top: 10% !important;
    }

.two-image-class {
  padding: 1em;
  /* padding-left: 5rem;
  padding-right: 5rem;
  padding-top: 4rem; */
}
@media (min-width: 1200px) {
    .container-xl, .container-lg, .container-md, .container-sm, .container {
        max-width: 1400px;
    }
    .pt-md-0, .py-md-0 {
        padding-top: 10% !important;
    }
}


@media (max-width: 768px) {
   .pt-md-0, .py-md-0 {
        padding-top: 10% !important;
    }
    .boldText{
    font-size: 30px;
  }
  .font-class-ref {
    font-size: 1.7vw
  }
}

@media (max-width: 567px) {
    .boldText{
    font-size: 30px;
  }
  .two-image-class {
    padding: 0;
  }

  .font-class-ref {
    font-size: 5vw
  }

  .font-class-ref-1 {
    font-size: 5vw
  }

  .country-class {
    width: 30vw;
    height: 15vw;
  }

  .country-container-class {
    width: 0;
  }

}
</style>
